// @flow
import snakeCase from 'lodash-es/snakeCase';
import type {DataTables} from 'datatables.net';

export default function style(column: String, options: any,
    dtSettings: DataTables.Settings, component: JQuery) {
        let dtColumn= dtSettings.columns.find(c => c.title == column);
        Object.keys(options).forEach(option => dtColumn[snakeCase(option)] = options[option]);
}